// extracted by mini-css-extract-plugin
module.exports = {"switchbase":"BaseSwitcher_switchbase__5RNae","baseimage":"BaseSwitcher_baseimage__3wqN7"};